export const REQUEST = 'Admin/PrizeCategories/REQUEST';
export const SUCCESS = 'Admin/PrizeCategories/SUCCESS';
export const ERROR = 'Admin/PrizeCategories/ERROR';

export const SET = 'Admin/PrizeCategories/SET';
export const DELETED = 'Admin/PrizeCategories/DELETED';
export const UPDATED = 'Admin/PrizeCategories/UPDATED';
export const ADDED = 'Admin/PrizeCategories/ADDED';